// M97a (R4) — the ONE name a factory build is minted with.
//
// Two places used to spell this literal independently: the minter
// (`factoryBuild.ts`) and, after M97a, the naming rule (`configurationLabel.ts`),
// which treats a build called exactly this as "no name worth printing" and
// prints the gun instead. A literal in two files drifts; a constant in one
// cannot. It lives in its own leaf so `configurationLabel.ts` (a pure lib
// imported by `rangeReconcile.ts` and `magCloseOut.ts`) never pulls the
// Supabase client in through the minter. `factoryBuild.ts` re-exports it.
//
// Keyed on the NAME, never on `is_factory_stock` (R17): four of the owner's
// nine factory-stock builds carry his own names, and those names are the
// whole point of M97a.
export const FACTORY_BUILD_NAME = 'Factory';
